import React from "react";
const SvgTrash = props => (
  <svg viewBox="0 0 22 25" {...props}>
    <path
      fill="none"
      stroke="#697684"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
      d="M14.7 8.3v11.2V8.3zm-7.4 0v11.2V8.3zm3.7 0v11.2V8.3zm4-5A2.3 2.3 0 0012.7 1H9.3A2.3 2.3 0 007 3.3V4h8v-.7zM1 4h20H1zm14.1 20H7a3 3 0 01-3-2.9L3 4h16l-.9 17.1a3 3 0 01-3 2.9z"
    />
  </svg>
);
export default SvgTrash;
